import SEO from "@/components/SEO";
import Footer from "@/components/Footer";
import NavbarDesktop from "@/components/desktop/marketplace/NavbarDesktop";
import HeroDesktop from "@/components/desktop/marketplace/HeroDesktop";
import HeroMobile from "@/components/mobile/marketplace/HeroMobile";
import ValuePillarsDesktop from "@/components/desktop/marketplace/ValuePillarsDesktop";
import FeaturedProducts from "@/components/FeaturedProducts";
import LocalTrustBento from "@/components/desktop/marketplace/LocalTrustBento";
import HowItWorksStrip from "@/components/desktop/marketplace/HowItWorksStrip";
import CommunityAndLetter from "@/components/desktop/marketplace/CommunityAndLetter";
import { useSectionTracking } from "@/hooks/useSectionTracking";
import { buildServiceSchema } from "@/lib/structuredData";

/**
 * Index — Landing oficial del Marketplace P2P de LEGO en tu ciudad.
 * Basada en la arquitectura y estética visual adaptativa de alta conversión.
 */
const Index = () => {
  useSectionTracking();

  const marketplaceSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Brickshare — Alquiler de sets LEGO® entre particulares en tu ciudad",
    description:
      "Alquila sets oficiales de LEGO® a fans de tu ciudad por días o semanas con total seguridad o comparte los tuyos.",
    url: "https://www.brickshare.org/",
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] dark:bg-background text-stone-900 dark:text-foreground">
      <SEO
        title="Brickshare — Alquiler de sets LEGO® entre vecinos en tu ciudad"
        description="El próximo LEGO® que quieres montar ya lo tiene tu vecino. Alquila sets por días o semanas en tu ciudad con entrega en mano o envío."
        keywords="alquiler lego, compartir lego, marketplace lego, lego segunda mano, intercambio sets lego"
        canonical="https://www.brickshare.org/"
        schema={[marketplaceSchema, buildServiceSchema()]}
      />
      <NavbarDesktop />
      <main>
        {/* Visualización adaptativa de la Cabecera Hero con carrusel de vídeo continuo */}
        <div className="hidden md:block">
          <HeroDesktop />
        </div>
        <div className="block md:hidden">
          <HeroMobile />
        </div>
        <ValuePillarsDesktop />
        <FeaturedProducts />
        <LocalTrustBento />
        <HowItWorksStrip />
        <CommunityAndLetter />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
